<div class="melding">
	<div class="header">
		<app-icon name="refresh" size="large" color="primary-1"></app-icon>
		<span class="text-head">Er is iets misgegaan</span>
	</div>
	<span class="text-small-content">De gedeelde pagina is niet gevonden.</span>
</div>
